import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import Title from "designs/v1/components/Title";
import Button from "designs/v1/components/Button";
import Loader from "designs/v1/pages/ModifyKyc/components/Loader";
import {
  validatePhoneOrEmailApi,
  createPhoneModifyRequest,
  createOtpRequest,
} from "designs/v1/pages/ModifyKyc/services";
import { validateOnNumber, validateOnPaste } from "utils";

const EmailModification = ({
  stageScreen,
  setStageScreen,
  setStep,
  isLoading,
  setIsLoading,
  activeUserDetail,
}) => {
  const initialValues = {
    email: "",
  };
  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email("Invalid email address.")
      .required("Email address is required."),
  });

  const handleSubmit = async (value) => {
    // if (activeUserDetail.email === value.email) {
    //   return toast.error("Please enter new email address.");
    // }
    try {
      setIsLoading(true);
      const payload = {
        verification_type: "email",
        verification_entity: value.email,
      };
      const resp = await validatePhoneOrEmailApi(payload);
      const isExist = resp.data.data?.present;
      setIsLoading(false);
      if (isExist) {
        return toast.error(resp.data.message?.message);
      }
    } catch (error) {
      const { data } = error.response || {};
      setIsLoading(false);
      return toast.error(
        data.message?.message || "Internal server error!"
      );
    }
    const payload = {
      request_type: stageScreen,
      modification_mobile_number: activeUserDetail.phone,
      modification_email: value.email,
      doc_name: localStorage.getItem("EmailRequestNumber"),
    };
    console.log("payload", payload);
    setIsLoading(true);
    try {
      const reqresp = await createPhoneModifyRequest(payload);
      if (reqresp.data.message?.status_code !== 200) {
        setIsLoading(false);
        return toast.error(reqresp.data.message?.message);
      }
      try {
        const resp = await createOtpRequest({
          request_type: stageScreen,
          doc_name: localStorage.getItem("EmailRequestNumber"),
        });
        setIsLoading(false);
        if (resp.data.message?.status_code !== 200) {
          return toast.error(resp.data.message?.message);
        }
        setStep("EmailOtpVerify");
      } catch (error) {
        setIsLoading(false);
        const { data } = error.response || {};
        toast.error(data.message?.message || "Internal server error!");
      }
    } catch (error) {
      setIsLoading(false);
      const { data } = error.response || {};
      toast.error(data.message?.message || "Internal server error!");
    }
  };
  return (
    <>
      <Title title="Email Modification" />
      <div className="row">
        <div className="col-md-9">
          <div className="form-group">
            <div className="mb-2">
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                {({ isValid, dirty, isSubmitting }) => (
                  <Form>
                    <div className="form-group my-2">
                      <label className="py-1">New Email Address</label>
                      <Field
                        type="text"
                        name="email"
                        placeholder="New Email Address"
                        className="form-control"
                        autoFocus={true}
                      />
                      <ErrorMessage
                        name="email"
                        className="inline-errormsg my-1"
                        component="div"
                      />
                    </div>
                    <div className="d-flex form-group my-4">
                      <div className="">
                        <Button
                          type="button"
                          title="Back"
                          handleClick={() => setStep("DematUccForm")}
                        />
                      </div>
                      <div className="mx-2">
                        <Button title="Submit" disabled={isLoading} />
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmailModification;
